import React, { useState, useEffect } from "react";

export default function CountdownTimer({ schedule }) {
  // Find the next varsity game (varsity time not TBD or "-")
  const nextGame = schedule.find((game) => {
    const gameDate = new Date(`${game.date} 2025 19:00`);
    return (
      gameDate > new Date() &&
      game.varsity &&
      game.varsity !== "TBD" &&
      game.varsity !== "-"
    );
  });

  // Always define hooks, even if nextGame is null
  const calculateTimeLeft = () => {
    if (!nextGame) return {};
    const gameDate = new Date(`${nextGame.date} 2025 ${nextGame.varsity}`);
    const diff = gameDate - new Date();
    if (diff <= 0) return {};
    return {
      days: Math.floor(diff / (1000 * 60 * 60 * 24)),
      hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((diff / (1000 * 60)) % 60),
      seconds: Math.floor((diff / 1000) % 60),
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    if (!nextGame) return;
    const timer = setInterval(() => setTimeLeft(calculateTimeLeft()), 1000);
    return () => clearInterval(timer);
  }, [nextGame]);

  // If no next game found
  if (!nextGame)
    return <p className="countdown-finished">No upcoming varsity games found.</p>;

  // If the countdown hits 0
  if (Object.keys(timeLeft).length === 0)
    return <p className="countdown-finished">It’s Game Time!</p>;

  // Display the countdown
  return (
    <div className="countdown-timer">
      <h3>Next Varsity Game</h3>
      <h4>vs {nextGame.opponent}</h4>
      <p className="countdown-location">
        {nextGame.home
          ? "Home Game"
          : `Away at ${nextGame.site}`}
      </p>
      <div className="time-box">
        <span>{timeLeft.days}d</span> :
        <span>{timeLeft.hours}h</span> :
        <span>{timeLeft.minutes}m</span> :
        <span>{timeLeft.seconds}s</span>
      </div>
    </div>
  );
}
